module.exports = "/fonts/vendor/lightcase/src/lightcase.eot?b956490107d6da53f6a9dc756c870fb1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightcase/src/fonts/lightcase.eot?55356177
// module id = 190
// module chunks = 1 2